import { render } from "./BusinessIntegrity.vue?vue&type=template&id=01612d75&scoped=true"
import script from "./BusinessIntegrity.vue?vue&type=script&lang=js"
export * from "./BusinessIntegrity.vue?vue&type=script&lang=js"

import "./BusinessIntegrity.vue?vue&type=style&index=0&id=01612d75&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01612d75"]])

export default __exports__